import { FC } from 'react';

const Payment: FC = () => {
	return <div>Payment</div>;
};

export default Payment;
